export default __webpack_public_path__ + "static/media/atendimentoIcone.c2bec8ab.svg";